import axios from 'axios'
import config from '@/config'
import { interceptorRequestSetup } from './interceptors/request'
import { interceptorResponseSuccess } from './interceptors/response'

const data = axios.create({ baseURL: config.DATA_URL })

data.interceptors.request.use(interceptorRequestSetup)
data.interceptors.response.use(interceptorResponseSuccess)

export default data
